/*
	DO NOT MODIFY MANUALLY
	Generated by: generateModel.ts
*/

import { AssetTypes, SaleInterestPayoutPeriod, SaleStatus } from '../types/utils';
import { InvestmentID } from './investment-model';
import { File } from './file-model';

export type SaleID = string;

export class Sale {
	id: SaleID = ''

	assetType: AssetTypes = AssetTypes.LOAN

	startDate: Date = new Date()

	endDate: Date = new Date()

	sharesCap: number = 0

	minPurchase: number = 0

	maxPurchase: number = 0

	interestRate: number = 0

	interestPayoutPeriod: SaleInterestPayoutPeriod = SaleInterestPayoutPeriod.YEARLY

	fee: number = 0

	name: string = ''

	description: string = ''

	company: string = ''

	baFinId: string = ''

	createdAt?: Date

	updatedAt?: Date

	investments?: Array<InvestmentID>

	images?: Array<File>

	sharesLocked: number = 0

	sharesSold: number = 0

	status: SaleStatus = SaleStatus.ACTIVE
}